// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__7KXJS","question":"styles_question__lhgws","answersContainer":"styles_answersContainer__swFRK"};